<!-- Details on the DatePicker library: https://www.npmjs.com/package/vue2-datepicker -->
<template>
  <date-picker
    v-model="value"
    v-on:is-shown="onShow"
    :name="schema.options.name"
    :id="schema.id"
    :default-value="schema.defaultDate"
    :placeholder="schema.placeholder"
    :confirm-text="schema.options.confirmText"
    :disabled="disabled"
    :disabled-date="schema.options.disabledDate"
    :range-separator="schema.options.rangeSeparator"
    value-type="format"
    :formatter="customFormatter"
    v-bind="schema.options"
  />
</template>

<script>
import { abstractField } from 'vue-form-generator';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';


export default {
  components: { DatePicker },
  mixins: [abstractField],
  data() {
    return {
      customFormatter: {
        // Date to String
        // eslint-disable-next-line
        stringify: function (date) {
          return date ? moment(date).format('L') : null;
        },
        // String to Date
        // eslint-disable-next-line
        parse: function (value) {
          return value ? moment(value, 'L').toDate() : null;
        },
      },
    };
  },
  methods: {
    onShow() {
      const defaultDate = this.schema.options.defaultDate;
      if (!this.value && defaultDate) {
        this.value = defaultDate;
      }
    },
  },
};
</script>
<style>
.mx-datepicker {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldDatePicker.vue